import weddingpeApp from "./Redux/Reducer/AppReducer";
import vmRootReducer from "./redux/reducers/rootReducer";

/**
 * VenueMonk-style lead-form stack under `redux/` (uses `vmApp` for VM `AppReducer`),
 * plus WeddingPe loan/home state under `app` (existing `AppReducer`).
 */
export default function rootReducer(state = {}, action) {
  const vmState = vmRootReducer(state, action);
  return {
    ...vmState,
    vmApp: vmState.app,
    app: weddingpeApp(state.app, action),
  };
}
